// 릴레이 채널 카테고리 규칙. 매니저앱 src/component/facility/iotChannels.js 와 같은 파일 (양쪽 같이 고칠 것)
//
// 채널(1~8)은 기본적으로 "전원" 묶음에 있고, 관리자가 카테고리 카드(조명/냉난방/전광판/운동기구/기타)에 넣고 뺀다 (9/17).
// 카테고리는 릴레이 row 의 category 로 저장된다. null = 어느 카드에도 안 들어간 전원.
export const ALL_CHANNELS = [1, 2, 3, 4, 5, 6, 7, 8]

// 카드 단위 카테고리. 냉난방 카드는 AIRCON+HEATING 두 릴레이 카테고리를 묶는다
export const CATEGORY_CARDS = [
  { key: 'LIGHT', label: '조명', relayCategories: ['LIGHT'] },
  { key: 'CLIMATE', label: '냉난방', relayCategories: ['AIRCON', 'HEATING'] },
  { key: 'DISPLAY', label: '전광판', relayCategories: ['DISPLAY'] },
  { key: 'EQUIPMENT', label: '운동기구', relayCategories: ['EQUIPMENT'] },
  { key: 'ETC', label: '기타', relayCategories: ['ETC'] },
]
export const cardOf = (key) => CATEGORY_CARDS.find((c) => c.key === key)
// 카드에 채널을 넣을 때 저장할 릴레이 카테고리 (냉난방은 AIRCON 으로 저장)
export const relayCategoryForCard = (key) => cardOf(key)?.relayCategories[0]

export const isOn = (channels, ch) => channels?.[`l${ch}`]?.onOff === 'on'

/** 릴레이 목록 → 채널별 {channel, category, name, enabled}. 릴레이 row 가 없는 채널은 카테고리 없음 */
export const buildChannelMap = (relays) => {
  const byChannel = Object.fromEntries((Array.isArray(relays) ? relays : []).map((r) => [r.relayChannel, r]))
  const map = {}
  ALL_CHANNELS.forEach((ch) => {
    const relay = byChannel[ch]
    map[ch] = {
      channel: ch,
      category: relay?.category || null,
      name: relay?.relayName || `전원 ${ch}`,
      enabled: relay ? relay.useYn !== 'N' : true,
    }
  })
  return map
}

/** 카드에 속한 채널 번호 (미사용 포함) */
export const channelsOfCard = (relays, cardKey) => {
  const cats = cardOf(cardKey)?.relayCategories || []
  return Object.values(buildChannelMap(relays))
    .filter((c) => cats.includes(c.category))
    .map((c) => c.channel)
}

/** 카드에 속하고 사용 중(useYn≠N)인 채널 번호 */
export const enabledChannelsOfCard = (relays, cardKey) => {
  const cats = cardOf(cardKey)?.relayCategories || []
  return Object.values(buildChannelMap(relays))
    .filter((c) => cats.includes(c.category) && c.enabled)
    .map((c) => c.channel)
}

/** 릴레이에 채널이 하나라도 들어 있는 카드 키 목록 */
export const presentCards = (relays) => CATEGORY_CARDS.filter((c) => channelsOfCard(relays, c.key).length > 0).map((c) => c.key)

/** 어느 카드에도 안 들어간 채널 (전원 카드). 미사용 포함 */
export const unassignedChannels = (relays) =>
  Object.values(buildChannelMap(relays))
    .filter((c) => !c.category)
    .map((c) => c.channel)

/** 어느 카드에도 안 들어가고 사용 중인 채널 (전원 카드 전체 토글용) */
export const enabledChannels = (relays) =>
  Object.values(buildChannelMap(relays))
    .filter((c) => !c.category && c.enabled)
    .map((c) => c.channel)

/** 채널 목록의 켜짐 요약 {onCount, total, allOn} */
export const summarize = (channels, list) => {
  const onCount = list.filter((ch) => isOn(channels, ch)).length
  return { onCount, total: list.length, allOn: list.length > 0 && onCount === list.length }
}

/**
 * 채널 목록("1,2,7" 또는 [1,2,7])을 사람이 읽는 라벨로. 카드 기준.
 * 예: "조명 전체 · 냉난방 6", 8개 전부면 "전체"
 */
export const describeChannels = (rly, relays) => {
  const list = (Array.isArray(rly) ? rly : String(rly || '').split(','))
    .map((v) => Number(String(v).trim()))
    .filter((n) => n >= 1 && n <= 8)
  if (list.length === 0) return ''
  if (list.length === 8) return '전체'
  const map = buildChannelMap(relays)
  const parts = []
  CATEGORY_CARDS.forEach((card) => {
    const inCard = channelsOfCard(relays, card.key)
    const hit = list.filter((n) => inCard.includes(n))
    if (hit.length === 0) return
    parts.push(hit.length === inCard.length ? `${card.label} 전체` : `${card.label} ${hit.join(',')}`)
  })
  const loose = list.filter((n) => !map[n].category)
  if (loose.length > 0) parts.push(`전원 ${loose.join(',')}`)
  return parts.join(' · ')
}
